import { useWindowSize } from 'usehooks-ts';

export function useBreakpoints() {
  const windowSize = useWindowSize();
  const isSmall = windowSize.width <= 1024;
  const isMedium = windowSize.width ? windowSize.width >= 1280 : false;
  const isLarge = windowSize.width ? windowSize.width >= 1920 : false;

  return {
    isSmall,
    isMedium,
    isLarge,
  };
}
